import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";

const TABS = [
  { to: "/", label: "Free Webinar" },
  { to: "/workshop", label: "AI Empire Workshop" },
];

export default function Header() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#0a0f0a]/85 backdrop-blur border-b border-[rgba(196,255,61,0.15)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between gap-4">
        {/* Brand */}
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="w-7 h-7 rounded-md bg-[#C4FF3D] flex items-center justify-center shadow-[0_0_18px_rgba(196,255,61,0.5)]">
            <Sparkles className="w-4 h-4 text-[#0a0f0a]" />
          </span>
          <span className="display-font text-white font-extrabold tracking-tight text-lg md:text-xl">
            viral<span className="text-[#C4FF3D]">X</span>
          </span>
        </Link>

        {/* Tabs */}
        <nav className="flex items-center gap-1 md:gap-2 p-1 rounded-full border border-[rgba(196,255,61,0.2)] bg-[#0e1410]/80 backdrop-blur">
          {TABS.map((t) => {
            const active = pathname === t.to;
            return (
              <Link
                key={t.to}
                to={t.to}
                className={`px-3 md:px-5 py-2 rounded-full text-xs md:text-sm font-semibold transition-colors duration-200 ${
                  active
                    ? "bg-[#C4FF3D] text-[#0a0f0a] shadow-[0_0_18px_rgba(196,255,61,0.45)]"
                    : "text-white/70 hover:text-white"
                }`}
              >
                {t.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
